
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.422 5.707a48.7 48.7 0 016.908 1.111c.25.06.413.301.376.558l-1.104 7.72c-.532 3.719-3.837 6.375-7.53 6.052-3.694-.323-6.488-3.513-6.366-7.267l.253-7.795a.498.498 0 01.467-.484 48.657 48.657 0 016.996.105zM10.62 15.32c-.134 1.557 1.518 2.974 3.69 3.167 2.172.192 4.042-.913 4.176-2.47.068-.791-1.93-.185-3.933-.348-1.931-.157-3.867-1.113-3.933-.349zM8.935 2.947a50.187 50.187 0 017.124.01.75.75 0 11-.108 1.496 48.605 48.605 0 00-13.081.822l.888 7.051c.277 2.203 1.599 3.94 3.657 4.673a.75.75 0 01-.503 1.413c-2.587-.92-4.294-3.13-4.642-5.898l-.975-7.738a.75.75 0 01.586-.827 50.187 50.187 0 017.054-1.002zm6.945 8.824c-.095 1.1 3.838 1.45 3.933.35.095-1.101-.708-2.071-1.794-2.168-1.086-.096-2.043.718-2.139 1.818zm-5.899-.522c-.095 1.1 3.838 1.449 3.933.348.095-1.1-.708-2.07-1.794-2.167-1.086-.096-2.044.718-2.139 1.819z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    